// extracted by mini-css-extract-plugin
module.exports = {"button":"followers_button__LbkXu","sending":"followers_sending__3oQ9a"};